import React from 'react';

import { TFunction } from 'i18next';

import { EventJournalModalQueries } from '@entities/eventJournal/model/queries';
import { changeTariff } from '@entities/tariff/lib';
import { useNuqsQueryState } from '@shared/hooks';
import { Icon, UiText, UiButton, EmptyListItemsPlaceholder } from '@shared/ui';

import cls from '../EventJournalBody/EventJournalBody.module.css';

interface IEmptyEventsListPlaceholderProps {
    canCreateCustomEvent: boolean;
    isOwner: boolean;
    t: TFunction<'translation', undefined>;
}

export const EmptyEventsListPlaceholder = ({
    canCreateCustomEvent,
    isOwner,
    t,
}: IEmptyEventsListPlaceholderProps) => {
    const { setState: setModalMode } = useNuqsQueryState(EventJournalModalQueries.queryName);
    const handleCreateEventBtn = async () => {
        await setModalMode(EventJournalModalQueries.queryCreate);
    };
    return (
        <EmptyListItemsPlaceholder
            className={cls.EmptyListItemsPlaceholder}
            header={<Icon iconName="drawer" fill="#D1D9E8" />}
            main={
                <>
                    <UiText tag="h3" variant="heading" weight="semibold" align="center">
                        {t('JournalEvents.EmptyEventsPlaceholder.NoEvents')}
                    </UiText>
                    <UiText tag="h4" variant="plain" align="center">
                        {t('JournalEvents.EmptyEventsPlaceholder.EmptyPeriod')}
                    </UiText>
                </>
            }
            footer={
                <UiButton
                    btnText={t('EventJournal.Header.createEventBtn')}
                    onClick={async () => {
                        if (!canCreateCustomEvent) {
                            await changeTariff(isOwner);
                            return;
                        }
                        await handleCreateEventBtn();
                    }}
                />
            }
        />
    );
};
